import EntityAudits from "@/components/EntityAudits.vue";
import {
  EntityDocumentForm,
  EntityDocumentMultipleForm,
  EntityDocuments,
  EntityDocumentsChildList,
} from "@modernary/mui/components/document";
import { EntityNotes } from "@modernary/mui/components/note";
import { RouterView, type RouterOptions } from "vue-router";

const names = {
  releaseEvents: "ReleaseEvent.ReleaseEvents",
  list: "ReleaseEvent.ReleaseEventList",
  base: "ReleaseEvent.ReleaseEventBase",
  view: "ReleaseEvent.ReleaseEventView,",
  new: "ReleaseEvent.ReleaseEventNew",
  edit: "ReleaseEvent.ReleaseEventEdit",
  statusChildList: "ReleaseEvent.ReleaseEventStatusChildList",
  statusChange: "ReleaseEvent.ReleaseEventStatusChange",
  projectOfficerChange: "ReleaseEvent.ReleaseEventProjectOfficerChange",
  confirm: "ReleaseEvent.ReleaseEventConfirmRelease",
  notes: "ReleaseEvent.ReleaseEventNotes",
  noteEdit: "ReleaseEvent.ReleaseEventNoteEdit",
  noteNew: "ReleaseEvent.ReleaseEventNoteNew",
  documents: "ReleaseEvent.ReleaseEventDocuments",
  documentEdit: "ReleaseEvent.ReleaseEventDocumentEdit",
  documentNew: "ReleaseEvent.ReleaseEventDocumentNew",
  audit: "ReleaseEvent.ReleaseEventAudit",
};

export { names as releaseEventRouteNames };

const releaseEventRoutes: RouterOptions["routes"] = [
  {
    path: "/releaseEvents",
    name: names.releaseEvents,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: { title: "Release Events", lookupGroups: ["ReleaseEventStatus"] },
        component: () => import("@/views/releaseEvent/ReleaseEventList.vue"),
      },
      {
        path: "new/:facilityId(\\d+)?",
        component: () => import("@/views/releaseEvent/ReleaseEventBase.vue"),
        redirect: { name: names.new },
        props: true,
        children: [
          {
            path: "",
            name: names.new,
            meta: { title: "Release Event New", isNew: true },
            component: () => import("@/views/releaseEvent/ReleaseEventEdit.vue"),
          },
        ],
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/releaseEvent/ReleaseEventBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Release Event View" },
            component: () => import("@/views/releaseEvent/ReleaseEventView.vue"),
          },
          {
            path: "edit",
            name: names.edit,
            meta: { title: "Release Event Edit", isForm: true },
            component: () => import("@/views/releaseEvent/ReleaseEventEdit.vue"),
          },
          {
            path: "statusChildList",
            name: names.statusChildList,
            meta: { title: "Release Event Status Tracker" },
            component: () => import("@/views/releaseEvent/ReleaseEventStatusChildList.vue"),
          },
          {
            path: "statusChange", // Also accepts a query param - disconfirm = true
            name: names.statusChange,
            meta: { title: "Release Event Status Edit", isForm: true },
            component: () => import("@/views/releaseEvent/ReleaseEventStatusChange.vue"),
          },
          {
            path: "projectOfficerChange",
            name: names.projectOfficerChange,
            meta: { title: "Release Event Project Officer Edit", isForm: true },
            component: () => import("@/views/releaseEvent/ReleaseEventProjectOfficerChange.vue"),
          },
          {
            path: "confirm",
            name: names.confirm,
            meta: { title: "Release Event Status Edit", isForm: true },
            component: () => import("@/views/releaseEvent/ReleaseEventConfirmRelease.vue"),
          },
          {
            path: "notes",
            name: names.notes,
            meta: { title: "Release Event Notes" },
            component: {
              render: () => <EntityNotes idField="releaseEventId" routeNamePrefix="ReleaseEvent.ReleaseEventNote" />,
            },
          },
          {
            path: "notes/:annotationId(\\d+)",
            name: names.noteEdit,
            meta: { title: "Release Event Note Edit", isForm: true },
            component: () => import("@/views/releaseEvent/ReleaseEventNote.vue"),
          },
          {
            path: "notes/new",
            name: names.noteNew,
            meta: { title: "Release Event Note New", isForm: true },
            component: () => import("@/views/releaseEvent/ReleaseEventNote.vue"),
          },
          {
            path: "documents",
            name: names.documents,
            meta: { title: "Release Event Documents" },
            component: {
              render: () => <EntityDocumentsChildList resourceTypeKey="releaseEvent" />,
            },
          },
          {
            path: "documents/:documentId(\\d+)",
            name: names.documentEdit,
            meta: { title: "Release Event Document Edit", isForm: true },
            component: {
              render: () => <EntityDocumentForm resourceTypeKey="releaseEvent" />,
            },
          },
          {
            path: "documents/new",
            name: names.documentNew,
            meta: { title: "Release Event Document New", isForm: true },
            component: {
              render: () => <EntityDocumentMultipleForm resourceTypeKey="releaseEvent" />,
            },
          },
          {
            path: "activity",
            name: names.audit,
            meta: { title: "Release Event Audit Activity" },
            component: {
              render: () => <EntityAudits entityName="ReleaseEvent" />,
            },
          },
        ],
      },
    ],
  },
];
export default releaseEventRoutes;
